.ToastCloseButton {
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  background-color: var(--gray-3);
  border-radius: 50%;
  border: 1px solid var(--gray-8);
  height: 20px;
  width: 20px;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: var(--cyan-5);
  }
}
